import { render, staticRenderFns } from "./PriceBar.vue?vue&type=template&id=90815ba8&scoped=true"
import script from "./PriceBar.vue?vue&type=script&lang=js"
export * from "./PriceBar.vue?vue&type=script&lang=js"
import style0 from "./PriceBar.vue?vue&type=style&index=0&id=90815ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90815ba8",
  null
  
)

export default component.exports